import {
    FETCH_PRICES, FETCH_PRICES_SUCCESS, FETCH_PRICES_FAILURE,
    SAVE_PRICES, SAVE_PRICES_SUCCESS, SAVE_PRICES_FAILURE,
    EMPTY_PRICES, SET_PRICES
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const emptyPrices = () => ({
    type: EMPTY_PRICES
});

const fetchPrices = () => ({
    type: FETCH_PRICES
});

const fetchPricesSuccess = (data) => ({
    type: FETCH_PRICES_SUCCESS,
    data
});

const fetchPricesFailure = (error) => ({
    type: FETCH_PRICES_FAILURE,
    error
});

const savePrices = () => ({
    type: SAVE_PRICES
});

const savePricesSuccess = (data) => ({
    type: SAVE_PRICES_SUCCESS,
    data
});

const savePricesFailure = (error) => ({
    type: SAVE_PRICES_FAILURE,
    error
});

export const setPrices = (data) => ({
    type: SET_PRICES,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getPrices = () => (dispatch, getStore) => {
    dispatch(fetchPrices());

    return request(PATHS.prices.get(), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            console.log(response.data);
            dispatch(fetchPricesSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error saving prices', error);
            error.friendlyMessage = 'There was an error saving these prices. Please try again.';
            dispatch(fetchPricesFailure(error));
            return error;
        });
};

export const putPrices = () => (dispatch, getStore) => {
    dispatch(savePrices());

    let prices = getStore().prices.all;
    let body = prices.map((price) => {
        return {
            id: price.id,
            manuallyEnteredPrice: price.manuallyEnteredPrice === '' ? null : parseFloat(price.manuallyEnteredPrice)
        };
    });

    console.log(body);

    return request(PATHS.prices.save(), requestConfig('PATCH', body, getStore().auth.token))
        .then((response) => {
            dispatch(savePricesSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error saving prices', error);
            error.friendlyMessage = 'There was an error saving these prices. Please try again.';
            dispatch(savePricesFailure(error));
            return error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/PricesPage/store/actions.js